import type { TypedMyHotelInstantPhoto } from './-MyHotelInstantPhoto';
import RawMyHotelAccess from './MyHotelInstantPhoto.vue';
export * from './-MyHotelInstantPhoto';

/**
 * コンポーネントの幅は CSS変数の --photo-width で指定してください
 */
export const MyHotelInstantPhoto = RawMyHotelAccess as typeof TypedMyHotelInstantPhoto;
